import { reset } from 'src/store'

const loggedInStates = () => {
  return [
    'currentAccountingSync',
    'lastAccountingSync',
    'providers'
  ]
}

const defaultStates = () => {
  return {
    currentAccountingSync: null,
    lastAccountingSync: null,
    providers: []
  }
}

export default {
  namespaced: true,
  state: defaultStates(),
  mutations: {
    reset (state) {
      reset(state, loggedInStates(), defaultStates())
    },
    // Remove a provider
    removeProvider (state, provider) {
      let index
      if (provider && (index = state.providers.indexOf(provider)) > -1) {
        state.providers.splice(index, 1)
        // Remove current accounting syncs stored in VueX if provider being removed is accounting
        if (provider.provider_type === 'accounting') {
          this.commit('providers/finishAccountingSync', null)
        }
      }
    },
    // Remove a provider based on provider_type
    removeProviderByType (state, providerType) {
      const findVal = state.providers.find(item => item.provider_type === providerType)
      this.commit('providers/removeProvider', findVal)
    },
    // Add new provider objects (and optionally replace existing of provider_type)
    addProviders (state, { value = [], replace = false }) {
      if (!Array.isArray(value)) {
        value = [value]
      }

      for (const provider of value) {
        // If replace mode, find existing item and remove before pushing new provider
        if (replace) {
          this.commit('providers/removeProviderByType', provider.provider_type)
        }
        state.providers.push(provider)
      }
    },
    setLastAccountingSync (state, value) {
      state.lastAccountingSync = value
    },
    setCurrentAccountingSync (state, value) {
      state.currentAccountingSync = value
    },
    finishAccountingSync (state, value) {
      this.commit('providers/setLastAccountingSync', value)
      this.commit('providers/setCurrentAccountingSync', null)
    }
  },
  getters: {
    getProviders: state => state.providers,
    getProviderByType: state => (value) => {
      return state.providers.find(item => item.provider_type === value)
    },
    getAccountingProvider: (state, getters) => {
      return getters.getProviderByType('accounting')
    },
    getPaymentProvider: (state, getters) => {
      return getters.getProviderByType('payment')
    },
    providersRequiringAttention: (state) => {
      return state.providers.filter(item => item.requires_auth || item.status !== 'LINKED')
    },
    hasAccountingProvider: (state, getters) => {
      return !!getters.getAccountingProvider
    },
    hasPaymentProvider: (state, getters) => {
      return !!getters.getPaymentProvider
    },
    hasLinkedAccountingProvider: (state, getters) => {
      const provider = getters.getAccountingProvider
      return provider && provider.status === 'LINKED'
    },
    hasLinkedPaymentProvider: (state, getters) => {
      const provider = getters.getPaymentProvider
      return provider && provider.status === 'LINKED'
    },
    getCurrentAccountingSync: state => {
      return state.currentAccountingSync
    },
    getExistingAccountingSync: state => {
      return state.currentAccountingSync || state.lastAccountingSync
    }
  }
}
